module.exports = __webpack_public_path__ + "f408b39f70de26d0dc689ecd433a43c3.svg";